import { c as _c } from "react/compiler-runtime";
import { ChevronsUpDown } from "lucide-react";
import React from "react";
import { Avatar } from "@components/ui/avatar";
import { DropdownMenu, DropdownMenuTrigger } from "@components/ui/dropdown-menu";
import { SidebarMenuButton } from "@components/ui/sidebar";
import { Skeleton } from "@components/ui/skeleton";
export const NavUserSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Avatar className="h-8 w-8 rounded-md bg-gray-200" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DropdownMenu><DropdownMenuTrigger asChild={true} disabled={true}><SidebarMenuButton size="lg" className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground">{t0}<div className="flex w-full flex-col gap-2"><Skeleton className="h-3 rounded-md bg-gray-200" /><Skeleton className="h-3 rounded-md bg-gray-200" /></div><ChevronsUpDown className="ml-auto size-4" /></SidebarMenuButton></DropdownMenuTrigger></DropdownMenu>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};